import { createRouter, createWebHistory } from "vue-router";
import Layout from "@/components/layout/Layout.vue";
import { useAuthStore } from "@/stores/authStore";
import { trackRouter } from "vue-gtag-next";
import { config } from "@/lib/variantConfig.ts";

const routes = [
  {
    path: "/",
    component: Layout,
    children: [
      { path: "/", component: () => import("@/pages/Home.vue") },
      { path: "/articles", component: () => import("@/pages/Articles.vue") },
      { path: "/magazines", component: () => import("@/pages/Magazines.vue") },
      { path: "/puzzles", component: () => import("@/pages/Puzzles.vue") },
      {
        path: "/saved",
        meta: { requiresAuth: true },
        component: () => import("@/pages/Saved.vue"),
      },
      ...(config.disable_subscription_page ? [] : [
        {
          path: "/account",
          meta: { requiresAuth: true },
          component: () => import("@/pages/Account.vue"),
        },
      ]),
    ],
  },
  {
    path: "/article/:id",
    component: () => import("@/pages/Article.vue"),
  },
  {
    path: "/edition/:id",
    component: () => import("@/pages/Edition.vue"),
  },
  {
    path: "/puzzle/:id",
    component: () => import("@/pages/Puzzle.vue"),
  },
  {
    path: "/auth/logout",
    component: () => import("@/pages/AuthLogout.vue"),
  },
  {
    path: "/deeplink",
    component: () => import("@/pages/DeepLink.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    component: () => import("@/pages/404.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.onError((error, to) => {
  if (
    error instanceof TypeError &&
    (error.message.includes("Failed to fetch dynamically imported module") ||
      error.message.includes("Importing a module script failed"))
  ) {
    const reloadKey = "chunk-reload:" + to.path;
    if (!sessionStorage.getItem(reloadKey)) {
      sessionStorage.setItem(reloadKey, "1");
      window.location.assign(to.fullPath);
    }
  }
});

router.afterEach((to) => {
  sessionStorage.removeItem("chunk-reload:" + to.path);
});

router.beforeEach(async (to, _from, next) => {
  const authStore = useAuthStore();

  if (to.meta.requiresAuth) {
    if (!(await authStore.checkAuth())) {
      next({ path: "/" });
      return;
    }
  }
  next();
});

trackRouter(router, {
  useScreenview: true,
});

export default router;
